import React from 'react';
import { ListTabsContextValue } from './types';

export const ListTabsContext = React.createContext<ListTabsContextValue | null>(null);

export function useListTabsContext(): ListTabsContextValue {
    const context = React.useContext(ListTabsContext);
    if (!context) {
        throw new Error('useListTabsContext must be used within a List');
    }
    return context;
}
